export default __webpack_public_path__ + "static/media/Sarah Glaspell-Elser.7f1d8051.png";